import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';
import Image from 'next/image';
import { trackEvent } from '../../../../utils/analytics';
import EventNames from '../../../../utils/event-name-constants';

function CourseCard({
  course, pageType, domainName, typeClasses,
}) {
  const router = useRouter();

  const formatDate = (date) => {
    if (!date) return 'N/A';
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = String(d.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };
    // testSeries card click
  const handleCardClick = (testList) => {
    // clever tab event
    trackEvent(EventNames.TESTSERIES_CARD_CLICKED, {
      timestamp: new Date().getTime(),
      testType: testList?.type,
      testDuration: testList?.duration,
      testID: testList?.id,
      testName: testList?.name,
      screenName: 'Test Series',
    });
    if (testList?.slug) {
      router.push(`/testseries/${testList?.slug}`); // redirect to detail page
    }
  };

  return (
    <div
      onClick={() => handleCardClick(course)}
      key={course?.id}
      className={`cursor-pointer lg:rounded-lg rounded-[6px] overflow-hidden bg-white border border-[#B8E5FF] ${pageType === 'Home' ? 'lg:w-[387px] w-full flex-flexAuto' : ''
      }`}
      lang={course?.language === 'Hindi' ? 'hi' : undefined}
    >
      <div className="relative p-[6px] pb-0">
        <span
          className={`${typeClasses[course.mode] || ''} inline-flex absolute items-center text-xs font-light rounded right-2.5 top-2.5 px-1 py-1 z-10`}
        >
          {course?.mode}
        </span>
        <div className="relative w-full aspect-[37/12] rounded-md overflow-hidden">
          <Image
            src={course.cardImage}
            alt="CardImage"
            fill
            className="object-cover"
            sizes="(max-width: 768px) 100vw, 640px"
          />
        </div>
      </div>

      <div className="lg:p-4 p-2 overflow-hidden">
        <div className="lg:mb-2 mb-[6px]">
          <span className="inline-flex items-center text-xs font-medium rounded me-1 bg-lightSky text-lightSky lg:p-[7px] p-1">
            {course.exam.name}
          </span>
          {domainName.organizationName === 'madeeasyprime' && (
          <span className="bg-[#D7FCF6] text-[#3FA897] inline-flex items-center text-xs font-medium rounded lg:p-[7px] p-1">
            {course?.stream?.name}
          </span>
          )}
        </div>

        <h2
          className={`lg:text-lg text-sm font-semibold text-black line-clamp-2 lg:mb-[14px] mb-2 ${pageType === 'Home' ? 'lg:h-14' : 'lg:h-14'
          }`}
        >
          {course?.name}
        </h2>

        <ul className="flex lg:mb-[19px] mb-[11px]">
          <li className="bg-[#F5F5F5] text-greyFont rounded p-[6px] text-xs font-light mr-2">
            {course?.courseLanguage}
          </li>
          <li className="bg-[#F5F5F5] text-greyFont rounded p-[6px] text-xs font-light">
            {course?.type}
          </li>
        </ul>

        <div className="bg-[#B8E5FF2E] lg:py-[13px] py-[11px] lg:px-4 px-[14px] rounded">
          <ul className="flex justify-between">
            <li className="flex items-center text-xs lg:text-sm text-greyFont">
              <span className="font-medium pr-1">Start Date:</span>
              {formatDate(course?.batches?.[0]?.commencementDate)}
            </li>
            <li className="flex items-center text-xs lg:text-sm text-greyFont">
              <span className="font-medium pr-1">Tests:</span>
              {course?.batches?.[0]?.mockTestEntityCount}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

CourseCard.propTypes = {
  course: PropTypes.object.isRequired,
  pageType: PropTypes.string.isRequired,
  domainName: PropTypes.object.isRequired,
  typeClasses: PropTypes.object.isRequired,
};

export default CourseCard;
